module.exports = __webpack_public_path__ + "static/bianco-e-nero-9be4f87c85bad2e0ecbe191c95b6e34c.jpg";